import { cn } from '@pcln/horizon'

const multiHotelVariants = {
  default: {
    gridContainer: [
      'grid grid-cols-1 gap-2 auto-rows-auto',
      "[grid-template-areas:'radio-option'_'repeat-form-controls'_'add-hotel'_'travelers-submit']",
      'sm:grid-cols-2 sm:gap-4',
      "sm:[grid-template-areas:'radio-option_.'_'repeat-form-controls_repeat-form-controls'_'add-hotel_.'_'travelers-submit_travelers-submit']",
      'xl:grid-cols-[1fr_1fr_1fr_1fr_1fr] xl:gap-y-4',
      "xl:[grid-template-areas:'radio-option_._._._.'_'repeat-form-controls_repeat-form-controls_repeat-form-controls_repeat-form-controls_repeat-form-controls'_'add-hotel_._._._.'_'travelers-submit_travelers-submit_travelers-submit_travelers-submit_travelers-submit']",
    ],
    formContainer: [],
  },
  // Compact variant - maintain sm layout through xl for homepage hero
  compact: {
    gridContainer: [
      'grid grid-cols-1 gap-2 auto-rows-auto',
      "[grid-template-areas:'radio-option'_'repeat-form-controls'_'add-hotel'_'travelers-submit']",
      'sm:grid-cols-2 sm:gap-4',
      "sm:[grid-template-areas:'radio-option_.'_'repeat-form-controls_repeat-form-controls'_'add-hotel_.'_'travelers-submit_travelers-submit']",
    ],
    formContainer: [],
  },
}

type MultiHotelVariant = keyof typeof multiHotelVariants

const multiHotelFormSlots = {
  formContainer: 'search-form-container',
  gridContainer: 'grid-container grid w-full [grid-area:grid-container]',
  radioGroup: 'radio-select [grid-area:radio-option] gap-0',
  datePicker: 'date-picker ',
  submitButton: 'submit-btn w-full',
  travelersSubmitContainer:
    'travelers-submit-container [grid-area:travelers-submit] grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-2',
  travelersWrapper: 'w-full',
  repeatFormControls:
    "repeat-form-controls [grid-area:repeat-form-controls] grid grid-cols-1 auto-rows-auto gap-6 [grid-template-areas:'hotel-multi']",
  hotelMulti: 'hotel-multi [grid-area:hotel-multi] grid grid-cols-1 gap-3',
  addHotelButton: 'btn-add-hotel md:max-w-[200px] justify-self-start [grid-area:add-hotel]',
  hotelRow: 'w-full flex flex-col gap-3',
  hotelHeader: 'pt-1 flex flex-row items-center justify-start gap-3',
  hotelInputsGrid: 'hotel-inputs grid grid-cols-1 gap-3 sm:grid-cols-2',
}

const getMultiHotelVariant = (useCompactLayout = false): MultiHotelVariant => {
  return useCompactLayout ? 'compact' : 'default'
}

export const getFormContainerClass = (useCompactLayout = false) => {
  const variant = getMultiHotelVariant(useCompactLayout)
  const styles = multiHotelVariants[variant]
  return cn(multiHotelFormSlots.formContainer, styles.formContainer)
}

export const getGridContainerClass = (useCompactLayout = false) => {
  const variant = getMultiHotelVariant(useCompactLayout)
  const styles = multiHotelVariants[variant]
  return cn(multiHotelFormSlots.gridContainer, styles.gridContainer)
}

export const getInputClass = (
  type:
    | 'radio'
    | 'datePicker'
    | 'submit'
    | 'repeatFormControls'
    | 'hotelMulti'
    | 'addHotelButton'
    | 'travelersSubmitContainer'
    | 'travelersWrapper'
    | 'hotelRow'
    | 'hotelHeader'
    | 'hotelInputsGrid',
) => {
  const inputMap = {
    radio: multiHotelFormSlots.radioGroup,
    datePicker: multiHotelFormSlots.datePicker,
    submit: multiHotelFormSlots.submitButton,
    repeatFormControls: multiHotelFormSlots.repeatFormControls,
    hotelMulti: multiHotelFormSlots.hotelMulti,
    addHotelButton: multiHotelFormSlots.addHotelButton,
    travelersSubmitContainer: multiHotelFormSlots.travelersSubmitContainer,
    travelersWrapper: multiHotelFormSlots.travelersWrapper,
    hotelRow: multiHotelFormSlots.hotelRow,
    hotelHeader: multiHotelFormSlots.hotelHeader,
    hotelInputsGrid: multiHotelFormSlots.hotelInputsGrid,
  } as const

  return inputMap[type]
}
